import { render, staticRenderFns } from "./UpgradedVersion.vue?vue&type=template&id=3863180c&"
import script from "./UpgradedVersion.vue?vue&type=script&lang=js&"
export * from "./UpgradedVersion.vue?vue&type=script&lang=js&"
import style0 from "./UpgradedVersion.vue?vue&type=style&index=0&id=3863180c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports